import { Injectable } from '@angular/core';
import { Program, UserDetails } from '../interfaces/user.interface';
import { catchError, Observable, Subject, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { formatUrl } from '../shared/utils/format-url-util';
import { ENDPOINTS } from '../shared/constants/url.constants';
import { HttpRequestService } from '../shared/services/http-request.service';
import { GlobalErrorHandlerService } from '../shared/services/global-error-handler.service';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  private trackingNumber?: string;
  private providerPPLId?: string;
  private providerId?: string;
  private participantPPLId?: string;
  private participantId?: string;
  private referral_source?: string;
  private referralConsumerId?: string;
  private first_menu?: string;
  private referralId?: number;
  private paBillRateId?: any;

  constructor() {}

  // Set tracking number (store in-memory)
  setTrackingNumber(trackingNumber: any): void {
    this.trackingNumber = trackingNumber;
  }

  // Get tracking number (in-memory)
  getTrackingNumber(): string | undefined {
    return this.trackingNumber;
  }

  // Set provider PPLId (store in-memory)
  setProviderId(providerId: any): void {
    this.providerId = providerId;
  }

  // Get provider PPLId (in-memory)
  getProviderId(): any {
    return this.providerId;
  }

  // Set participant PPLId (store in-memory)
  setParticipantPPLId(participantPPLId: any): void {
    this.participantPPLId = participantPPLId;
  }

  // Get participant PPLId (in-memory)
  getParticipantPPLId(): string | undefined {
    return this.participantPPLId;
  }

  // Set participant Id (store in-memory)
  setParticipantId(participantId: any): void {
    this.participantId = participantId;
  }

  // Get participant Id (in-memory)
  getParticipantId(): any {
    return this.participantId;
  }

  // Set referral source (store in-memory)
  setReferralSource(referral_source: any): void {
    this.referral_source = referral_source;
  }

  // Get referral source (in-memory)
  getReferralSource(): string | undefined {
    return this.referral_source;
  }

  // Set referral ConsumerId (store in-memory)
  setReferralConsumerId(referralConsumerId: any): void {
    this.referralConsumerId = referralConsumerId;
  }

  // Get referral ConsumerId (in-memory)
  getReferralConsumerId(): string | undefined {
    return this.referralConsumerId;
  }
  // Set provider PPLId (store in-memory)
  setProviderPPLId(providerPPLId: any): void {
    this.providerPPLId = providerPPLId;
  }

  // Get provider PPLId (in-memory)
  getProviderPPLId(): string | undefined {
    return this.providerPPLId;
  }
  // Set first_menu (store in-memory)
  setFirstMenu(first_menu: any): void {
    this.first_menu = first_menu;
  }

  // Get first_menu (in-memory)
  getFirstMenu(): string | undefined {
    return this.first_menu;
  }

  // Set referralId (store in-memory)
  setReferralId(referralId: any): void {
    this.referralId = referralId;
  }

  // Get referralId (in-memory)
  getReferralId(): number | undefined {
    return this.referralId;
  }

  // Set paBillRateId (store in-memory)
  setPaBillRateId(paBillRateId: any): void {
    this.paBillRateId = paBillRateId;
  }

  // Get paBillRateId (in-memory)
  getPaBillRateId(): any {
    return this.paBillRateId;
  }
}
